import { FullscreenModal } from '@xo-union/tk-component-modals';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from '@xo-union/react-css-modules';

import {
  useUpdatePurchaseDomainMutation,
  WeddingWebsiteQuery,
  WeddingWebsiteQueryDocument,
  Wws_PurchaseDomain,
} from '../../generated/graphql';
import styles from './index.scss';
import PaymentForm from './PaymentForm';

interface Props {
  domain?: Wws_PurchaseDomain;
}

const redemptionDescription =
  'Renew this domain using your credit or debit card. Since your domain has already expired, there is an increased renewal cost.';
const regularDescription = 'Renew this domain using your credit or debit card.';

const Renewal: React.FC<Props> = ({ domain }) => {
  const history = useHistory();
  const [updatePd, { loading: buying }] = useUpdatePurchaseDomainMutation();

  const onClose = () => history.push('/gs/dashboard');

  const onBuy = async (nonce: string, registrationLength: number) => {
    await updatePd({
      variables: {
        attributes: {
          paymentMethodNonce: nonce,
          years: registrationLength,
        },
      },
      update(cache, { data }) {
        const { weddingWebsite, ...rest } = cache.readQuery<WeddingWebsiteQuery>({
          query: WeddingWebsiteQueryDocument,
        })!;
        const updatedWeddingWebsite = { ...weddingWebsite, purchaseDomain: data?.updatePurchaseDomain };
        cache.writeQuery({
          query: WeddingWebsiteQueryDocument,
          data: { ...rest, weddingWebsite: updatedWeddingWebsite },
        });
      },
    });
    onClose();
  };

  const modalClasses = compose({
    'header-section': styles['header-section'],
    'header-section-center': styles['header-section-center'],
    'header-section-right': styles['header-section-right'],
    'tk-logo': styles['tk-logo'],
    container: styles['container'],
  });

  const description = !!domain?.isInRedemptionPeriod ? redemptionDescription : regularDescription;
  return (
    <div className={styles.modalWrapper}>
      <FullscreenModal onClose={onClose} contentClassName={styles.modalContent} classes={modalClasses}>
        <div className={styles.container}>
          <PaymentForm
            domainName={domain?.name || ''}
            domainPrice={domain?.renewalPrice || 0}
            isPremiumName={false}
            isInRedemptionPeriod={!!domain?.isInRedemptionPeriod}
            description={description}
            primaryText="Place order"
            secondaryText="Cancel"
            onCancel={onClose}
            onBuy={onBuy}
            loading={buying}
            headerText="Renew a Custom URL"
          />
        </div>
      </FullscreenModal>
    </div>
  );
};

export default Renewal;
